import { ContactRoleType } from "__generated__/enums";
import { Alert, Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { EmailWillBeSentToContactsAlertSalesCharterContactFragment } from "__generated__/view/charters/graphql/charter.fragments.generated";

const SalesCharterEmailRecipientAlert = ({ contacts, alertBody, alertStyle }: {
	contacts: EmailWillBeSentToContactsAlertSalesCharterContactFragment[];
	alertBody: ReactNode;
	alertStyle?: SxProps<Theme>
}) => contacts.length > 0 ? (
	<Alert severity="warning" sx={{ marginBottom: 1.5, ...alertStyle }}>
		<Box marginBottom={1}>
			{alertBody}
		</Box>

		<ul style={{ marginBottom: 0, paddingInlineStart: 24 }}>
			{contacts.filter(contact => contact.contactRoleType === ContactRoleType.NominationAndConfirmation)
				.map(salesCharterContact => salesCharterContact.contact)
				.map(contact => (
					<li key={contact.id}>
						{`${contact.name}${contact.email ? " (" + contact.email + ")" : ""}`}
					</li>
				))
			}
		</ul>
	</Alert>
) : undefined;

export default SalesCharterEmailRecipientAlert;
